import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { apiRequests } from '../../shared/api/apiRequests';
import { dateToString } from '../../shared/utils/parseDate';
import { Pagination } from '../../features/Pagination';
import { PageBar } from '../../shared/ui/PageBar';
import { EntityCard } from '../../shared/ui/EntityCard';

const CategoriesOfNewsPage = () => {
  const [data, setData] = useState({ items: [], totalCount: 0 });
  const [searchValue, setSearchValue] = useState('');
  const location = useLocation();

  const getData = (count = 10, offset = 0) => {
    apiRequests.news.getCategories(count, offset).then((res) => setData(res));
  };

  useEffect(() => {
    getData();
  }, []);

  const handleSearch = () => {
    if (searchValue === '') {
      getData();
    } else {
      apiRequests.news.getCategoriesFiltered(searchValue).then((res) => setData(res));
    }
  };

  const handleDelete = (id) => {
    apiRequests.news.deleteCategory(id).then(() =>
      setData((prev) => ({
        totalCount: prev.totalCount - 1,
        items: prev.items.filter((i) => i.id !== id),
      }))
    );
  };

  return (
    <>
      <PageBar
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        onSearch={handleSearch}
        searchPlaceholder="Поиск категорий..."
        createLink={`${location.pathname}/create`}
      />

      <div className="mb-3">
        {data.items?.length === 0 ? (
          <p className="text-center">По вашему запросу ничего не найдено</p>
        ) : (
          data.items?.map((item) => (
            <EntityCard
              key={item.id}
              title={item.title}
              fields={[
                { label: 'Создано', value: dateToString(item.createdAt) },
              ]}
              editLink={`${location.pathname}/${item.id}`}
              localizationLink={`${location.pathname}/${item.id}/localization`}
              onDelete={() => handleDelete(item.id)}
            />
          ))
        )}
      </div>

      <Pagination
        count={data.totalCount}
        itemsPerPage={10}
        onChange={(page) => getData(10, page * 10)}
      />
    </>
  );
};

export default CategoriesOfNewsPage;
